'use strict';

import { flow, action, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import events from '@uw-it-sis/lib-react/lib/Events';

import BookmarkEvents from './BookmarkEvents';
import bookmarksStore from './BookmarksStore';

/**
 * Store for handling bookmark actions (Add/Delete). Note: Bookmarks can be courses or programs.
 *
 * This store has to be instantiated.
 *
 * Note: Actual bookmark data is stored in BookmarksStore.
 */
class BookmarkWidgetStore {

    // This state is for performing actions on the state.
    state = States.initial;

    constructor() {
        makeObservable(this, {
            state: observable,
            mount: action
        });

        this.baseUrl = 'api/bookmarks';
        this.actionMessage = "";
        this.actionPendingItem = "";
    }

    /**
     * Resets the component.
     */
    mount() {
        this.actionPendingItem = "";
        this.actionPendingItem = "";
        this.state = States.initial;
    }

    /**
     * Handler for adding a bookmark.
     *
     * @param formData The data object from the form.
     */
    add = flow(function* (code, type) {
        this.state = States.pending;

        try {
            const newBookmark = yield appStore.getHttpClient().doPost(`${this.baseUrl}/${code}?type=${type}`, null, 'addBookmark');

            this.actionMessage = "Bookmarked successfully";
            this.state = States.done;

            // Fix the model by overwriting the code with the course code.
            newBookmark.code = code;
            // Announce that a bookmark was added ...
            events.emit(BookmarkEvents.added, newBookmark);
        } catch (error) {
            this.state = States.error;
        }
    }.bind(this));

    /**
     * Handler for deleting a bookmark.
     */
    delete = flow(function* (bookmarkId) {
        this.state = States.pending;

        // Find the bookmark code for the remove event.
        const bookmark = bookmarksStore.getBookmarkById(bookmarkId);
        const code = bookmark.code;

        try {
            yield appStore.getHttpClient().doDelete(`${this.baseUrl}/${bookmarkId}`, 'deleteBookmark');

            this.actionMessage = "Deleted successfully";
            this.state = States.done;
            // Emit removed bookmark
            events.emit(BookmarkEvents.deleted, code);
        } catch (error) {
            this.state = States.error;
        }
    }.bind(this));

    /*
     * Pass-thru to the BookmarksStore method.
     * True if a bookmark exists for the given code. Otherwise, false.
     */
    isBookmarked(code) {
        return bookmarksStore.isBookmarked(code);
    }

    /**
     * Pass-thru to the BookmarksStore method.
     * Gets a bookmark by its code.
     */
    getBookmarkByCode(code) {
        return bookmarksStore.getBookmarkByCode(code);
    }

    /**
     * Returns the code of the item when an action is pending.
     */
    getActionPendingItem() {
        return this.actionPendingItem;
    }
}

export default BookmarkWidgetStore;